export const allowedTracingUrls: { match: RegExp; propagatorTypes: ['datadog'] }[] = [
  { match: new RegExp('^https://(.*\\.)?klew\\.jp(/.*)?$'), propagatorTypes: ['datadog'] },
];
